/*
 * Copyright (c) 2015 - 2023 by KAA Soft. All rights reserved.
 */

import { isSelectorValid } from "./functions";
export var loadingElement = {
  start: function start(element) {
    if (element instanceof HTMLElement && element) {
      element.insertAdjacentHTML("beforeend", "<div class=\"loading-layer\"><div class=\"loading-spinner pulse pulse-primary\"></div></div>");
    }
    if (typeof element === "string" && isSelectorValid(element)) {
      var elements = document.querySelectorAll(element);
      for (var i = 0; i < elements.length; i++) {
        elements[i].insertAdjacentHTML("beforeend", "<div class=\"loading-layer\"><div class=\"loading-spinner pulse pulse-primary\"></div></div>");
      }
    }
  },
  finish: function finish(element) {
    if (element instanceof HTMLElement && element) {
      var subElements = element.querySelectorAll(".loading-layer");
      for (var i = 0; i < subElements.length; i++) {
        subElements[i].remove();
      }
    }
    if (typeof element === "string" && isSelectorValid(element)) {
      var elements = document.querySelectorAll(element);
      for (var _i = 0; _i < elements.length; _i++) {
        var _subElements = elements[_i].querySelectorAll(".loading-layer");
        for (var _i2 = 0; _i2 < _subElements.length; _i2++) {
          _subElements[_i2].remove();
        }
      }
    }
  }
};